import React from "react";
import {
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonCard,
  useIonPopover,
} from "@ionic/react";
import { useIntl } from "react-intl";
import {
  pencilOutline,
  logOutOutline,
  languageOutline,
  textOutline,
} from "ionicons/icons";
import LanguageSelector from "./LanguageSelector";

const SettingsList = (props) => {
  const { signaturePresent, presentTextSizer } = props;
  const intl = useIntl();
  const [present, dismiss] = useIonPopover(LanguageSelector, {
    onHide: () => dismiss(),
  });

  return (
    <IonCard>
      <IonList>
        <IonItem
          onClick={() => {
            signaturePresent();
          }}
          key={"signature"}
          button
        >
          <IonIcon icon={pencilOutline} slot="start" />

          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.signature",
            })}
          </IonLabel>
        </IonItem>

        <IonItem
          onClick={() => {
            presentTextSizer();
          }}
          key={"textSizer"}
          button
        >
          <IonIcon icon={textOutline} slot="start" />

          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.textSizer",
            })}
          </IonLabel>
        </IonItem>

        <IonItem href={`/logout`} key={"signout"} button lines="none">
          <IonIcon icon={logOutOutline} slot="start" />

          <IonLabel>
            {intl.formatMessage({
              id: "app.mobile.signout",
            })}
          </IonLabel>
        </IonItem>
      </IonList>
    </IonCard>
  );
};

export default SettingsList;

// <IonItem
//   onClick={(e) => {
//     present({
//       event: e.nativeEvent,
//     });
//   }}
//   key={"language"}
//   button
// >
//   <IonIcon icon={languageOutline} slot="start" />
//
//   <IonLabel>
//     {intl.formatMessage({
//       id: "app.mobile.language",
//     })}
//   </IonLabel>
// </IonItem>
